import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { Box, CircularProgress, Fab, Fade, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import InseaLogo from "~/assets/img/insea-no-text.svg";
import useAuth from "~/utils/hooks/useAuth";
import "./SplashPage.css";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "var(--full-vh, 100vh)",
    width: "100vw",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    background:
      "radial-gradient(ellipse at center, rgb(255 255 255) 0%, rgb(255 255 255) 35%, #d4f1f3 100%);",
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    marginTop: theme.spacing(1),
  },
  nodeonBlue: {
    color: "#002c71",
  },
}));

const SplashPage = (): JSX.Element => {
  const { t } = useTranslation("template");
  const { login, loginProgress } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);

  // const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Fade in appear timeout={{ enter: 1500 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={InseaLogo}
            sx={{ height: "200px", width: "200px" }}
          />
          <Typography variant="h4">InSea</Typography>
          <Fab
            className={classes.fab}
            color="primary"
            variant="extended"
            sx={{ zIndex: (theme) => theme.zIndex.modal }}
            onClick={() => {
              setIsLoggingIn(true);
              login()
                .catch((x) => {
                  console.error(x);
                  enqueueSnackbar(t("login:login-failed-unknown"), {
                    variant: "error",
                  });
                })
                .finally(() => setIsLoggingIn(false));
            }}
            disabled={loginProgress !== "none" || isLoggingIn}
          >
            {loginProgress !== "none" || isLoggingIn ? (
              <CircularProgress style={{ marginRight: "8px" }} size={24} />
            ) : (
              <VpnKeyIcon className={classes.extendedIcon} />
            )}

            {t("Login")}
          </Fab>
        </Box>
      </Fade>
      <div className="ocean">
        <div className="wave" />
        <div className="wave" />
      </div>
    </div>
  );
};

export default SplashPage;
